import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import selectors from 'store/selectors';
import CustomDialog from 'components/CustomDialog/customDialog';
import { setDialog } from 'store/actions/dialogActions';
import { ContentCnt } from './XeniaDocsModal.style';
import DIALOGS from 'utils/dialogIds';
import { Box, Typography } from '@mui/material';
import CustomDialogHeader from 'components/CustomDialog/DialogHeader/dialogHeader.cmp';
import SearchInput from 'components/Form/TextField/SearchField.cmp';
import SelectableFilesAndFoldersList from './FilesAndFoldersList';
import { debounce } from 'lodash';
import useDocumentsFolders from 'utils/CustomHooks/useDocumentsFolders';
import { getDocumentsFoldersBySearch } from 'api/documents';
import BreadCrumbs from './BreadCrumbs/breadCrumbs';

const XeniaDocs = () => {
  const dispatch = useDispatch();
  const { getFoldersDocuments } = useDocumentsFolders();

  const dialogState = useSelector(selectors.getDialogState);
  const { open, data } = dialogState?.[DIALOGS?.XENIA_DOCS_ATTACHMENTS] || {};
  const { linkDocs } = data;

  const handleClose = () => {
    dispatch(
      setDialog({
        open: false,
        dialogId: DIALOGS?.XENIA_DOCS_ATTACHMENTS,
      }),
    );
  };
  const [searchText, setSearchText] = useState('');
  const [selectedFolder, setSelectedFolder] = useState<any>(null);
  const [allDocuments, setAllDocusments] = useState<any>(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isLoading, setIsloading] = useState(true);

  const onChange = (e) => {
    setSearchText(e.target.value);
    changeHandler(e.target.value);
  };
  const changeHandler = useCallback(
    debounce((searchText) => {
      if (searchText.length) {
        searchFiles(searchText);
      } else {
        getFolderAndDocuments(selectedFolder ? selectedFolder?.id : null);
      }
    }, 500),
    [],
  );
  const searchFiles = async (searchText: string) => {
    setIsloading(true);
    const data = await getDocumentsFoldersBySearch({
      searchText,
      archived: 'archive',
    });
    const folders = data?.filter((item) => item.type === 'folder');
    const documents = data?.filter((item) => item.type === 'document');
    setAllDocusments({ folders, documents });
    setIsloading(false);
  };
  const getFolderAndDocuments = async (folderId?: string) => {
    setIsloading(true);
    const data = await getFoldersDocuments({
      folderId: folderId || null,
      archived: false,
      sortBy: 'createdAt',
      order: 'desc',
    });
    setAllDocusments(data);
    setIsloading(false);
  };
  useEffect(() => {
    if (selectedFolder) {
      getFolderAndDocuments(selectedFolder.id);
      return;
    }
    getFolderAndDocuments();
  }, [selectedFolder]);
  const handleLinkDocs = () => {
    linkDocs(selectedItems);
    handleClose();
  };
  return (
    <CustomDialog
      header={
        <CustomDialogHeader onClose={handleClose}>
          <Typography fontSize={'20px'} fontWeight={700}>
            Xenia Docs
          </Typography>
        </CustomDialogHeader>
      }
      actionButtonCntProps={{
        primaryBtnProps: {
          disabled: selectedItems.length === 0,
          onClick: handleLinkDocs,
        },
        secondaryBtnProps: { onClick: handleClose },
      }}
      primaryBtnText="Link to announcement"
      dialogProps={{
        open: open,
        fullWidth: true,
        onClose: handleClose,
        sx: {
          '& .MuiDialog-paper': {
            maxWidth: '650px',
          },
        },
      }}
    >
      <ContentCnt>
        <Box sx={{ p: 3 }}>
          <SearchInput
            onChange={onChange}
            fieldProps={{
              value: searchText,
            }}
            sx={{
              mb: 2,
              width: {
                sm: '100%',
                '& .MuiInputBase-adornedStart': {
                  background: '#F5F5F5',
                  borderRadius: '8px',
                },
                '& .MuiOutlinedInput-input': {
                  background: '#F5F5F5',
                },
              },
            }}
          />

          {selectedFolder && (
            <BreadCrumbs
              selectedFolder={selectedFolder}
              setSelectedFolder={setSelectedFolder}
            />
          )}
          <SelectableFilesAndFoldersList
            data={allDocuments}
            setSelectedFolder={setSelectedFolder}
            selectedFiles={selectedItems}
            setSelectedFiles={setSelectedItems}
          />
        </Box>
      </ContentCnt>
    </CustomDialog>
  );
};

export default XeniaDocs;
